module.exports = __webpack_public_path__ + "static/media/pandaisia_full1.01cd98fc.jpg";